export enum Environment {
	Production = 'production',
	Staging = 'staging',
	UAT = 'uat',
	HFX = 'hfx',
	DR = 'dr',
	Local = 'local'
}
